'use strict';

angular.module('app.insightReportBenchmark', [])
    .directive('insightReportBenchmarkDirective', function () {
        return {
            controller: 'insightReportBenchmarkCtrl',
            templateUrl: 'app/measure/insightReport/insightReportBenchmark/insightReportBenchmark.html?app_v=deployDate',
            restrict: 'E',
            scope: {
                
            },
            replace: true,
            transclude: true
        };
    })